"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sceneFailedNotificationGlossary = exports.sceneSuccessNotificationGlossary = exports.sceneWarningNotificationGlossary = exports.telegramBody = exports.printActuators = exports.printMonitors = void 0;
const enums_1 = require("../enums");
const utils_1 = require("../utils");
const general_1 = require("./general");
const pushHeadings = ({ notificationKind, applicationName, }) => ({
    [enums_1.SceneNotificationsKindEnum.EVENT_SCENE_SUCCESS]: {
        [enums_1.NotificationLanguagesEnum.it]: `✅ Scena completata — ${applicationName}`,
        [enums_1.NotificationLanguagesEnum.en]: `✅ Scene completed — ${applicationName}`,
    },
    [enums_1.SceneNotificationsKindEnum.EVENT_SCENE_FAILED]: {
        [enums_1.NotificationLanguagesEnum.it]: `🚨 Scena fallita — ${applicationName}`,
        [enums_1.NotificationLanguagesEnum.en]: `🚨 Scene failed — ${applicationName}`,
    },
    [enums_1.SceneNotificationsKindEnum.EVENT_SCENE_WARNING]: {
        [enums_1.NotificationLanguagesEnum.it]: `⚙️ Scena in esecuzione — ${applicationName}`,
        [enums_1.NotificationLanguagesEnum.en]: `⚙️ Scene ongoing — ${applicationName}`,
    },
}[notificationKind]);
const pushContents = ({ notificationKind, sceneName, automationName, }) => ({
    [enums_1.SceneNotificationsKindEnum.EVENT_SCENE_SUCCESS]: {
        [enums_1.NotificationLanguagesEnum.it]: `"${sceneName}" dell'automazione "${automationName}" è stata completata.`,
        [enums_1.NotificationLanguagesEnum.en]: `"${sceneName}" of automation "${automationName}" is completed.`,
    },
    [enums_1.SceneNotificationsKindEnum.EVENT_SCENE_FAILED]: {
        [enums_1.NotificationLanguagesEnum.it]: `"${sceneName}" dell'automazione "${automationName}" è fallita.`,
        [enums_1.NotificationLanguagesEnum.en]: `"${sceneName}" of automation "${automationName}" is failed.`,
    },
    [enums_1.SceneNotificationsKindEnum.EVENT_SCENE_WARNING]: {
        [enums_1.NotificationLanguagesEnum.it]: `"${sceneName}" dell'automazione "${automationName}" è in esecuzione.`,
        [enums_1.NotificationLanguagesEnum.en]: `"${sceneName}" of automation "${automationName}" is in progress.`,
    },
}[notificationKind]);
const printMonitors = (conditions, sceneDevices) => conditions.map((condition) => {
    const device = sceneDevices.find(sceneDevice => sceneDevice.id === Number(condition.deviceId));
    const { name } = device;
    const type = device.payloads.find(({ payload }) => payload?.key === condition.payloadKey.key)?.payload?.type ?? 'N/A';
    const value = 'value' in condition.payloadKey
        ? String(condition.payloadKey.value)
        : `${condition.payloadKey.valueMin} - ${condition.payloadKey.valueMax}`;
    return (0, utils_1.escapeForTg)(`${name}: ${condition.payloadKey.operator} ${value} ${type}`);
}).join('\n');
exports.printMonitors = printMonitors;
const printActuators = (actions, devices) => actions.map((sceneAction) => {
    const device = devices.find(device => device.id === Number(sceneAction.deviceId));
    const kind = device.actions.find(({ action: deviceAction }) => (deviceAction?.key === sceneAction.payloadAction.key
        && String(deviceAction?.value) === String(sceneAction.payloadAction.value)))?.action?.name.replace('-', ' ') ?? 'N/A';
    return (0, utils_1.escapeForTg)(`${device.name}: ${kind}`);
}).join('\n');
exports.printActuators = printActuators;
const telegramBody = ({ notificationKind, applicationName, automationName, sceneName, conditions, actions, devices, }) => {
    const body = (language) => {
        const actuators = (0, exports.printActuators)(actions, devices);
        return `
<b>${(0, utils_1.escapeForTg)(pushHeadings({ notificationKind, applicationName })[language])}</b>

${(0, utils_1.escapeForTg)(pushContents({ notificationKind, sceneName, automationName })[language])}

${general_1.generalGlossary[language].monitors}
${(0, exports.printMonitors)(conditions, devices)}

${actuators.length > 0 ? `
${general_1.generalGlossary[language].actuators}
${actuators}` : ''}
`;
    };
    return {
        [enums_1.NotificationLanguagesEnum.it]: body(enums_1.NotificationLanguagesEnum.it),
        [enums_1.NotificationLanguagesEnum.en]: body(enums_1.NotificationLanguagesEnum.en),
    };
};
exports.telegramBody = telegramBody;
exports.sceneWarningNotificationGlossary = {
    latestVersion: 1,
    1: {
        pushHeadings: ({ applicationName }) => pushHeadings({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_WARNING,
            applicationName,
        }),
        pushContents: ({ sceneName, automationName, }) => pushContents({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_WARNING,
            sceneName,
            automationName,
        }),
        telegramBody: ({ applicationName, automationName, sceneName, conditions, actions, devices, }) => (0, exports.telegramBody)({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_WARNING,
            applicationName,
            automationName,
            sceneName,
            conditions,
            actions,
            devices,
        }),
    },
};
exports.sceneSuccessNotificationGlossary = {
    latestVersion: 1,
    1: {
        pushHeadings: ({ applicationName }) => pushHeadings({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_SUCCESS,
            applicationName,
        }),
        pushContents: ({ sceneName, automationName, }) => pushContents({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_SUCCESS,
            sceneName,
            automationName,
        }),
        telegramBody: ({ applicationName, automationName, sceneName, conditions, actions, devices, }) => (0, exports.telegramBody)({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_SUCCESS,
            applicationName,
            automationName,
            sceneName,
            conditions,
            actions,
            devices,
        }),
    },
};
exports.sceneFailedNotificationGlossary = {
    latestVersion: 1,
    1: {
        pushHeadings: ({ applicationName }) => pushHeadings({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_FAILED,
            applicationName,
        }),
        pushContents: ({ sceneName, automationName, }) => pushContents({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_FAILED,
            sceneName,
            automationName,
        }),
        telegramBody: ({ applicationName, automationName, sceneName, conditions, actions, devices, }) => (0, exports.telegramBody)({
            notificationKind: enums_1.SceneNotificationsKindEnum.EVENT_SCENE_FAILED,
            applicationName,
            sceneName,
            automationName,
            conditions,
            actions,
            devices,
        }),
    },
};
